import {
  alertMessagesArgsConfig,
  redirectUrlArgsConfig,
  userRoleArgsConfig,
} from '../../../utils/event_constants';

export const oAuth2ActionData = [
  {
    name: 'loginWithOAuth2',
    label: 'Login with OAuth 2',
    args: [
      {
        name: 'successRedirectRules',
        label: 'Select Success Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      {
        name: 'errorRedirectUrl',
        label: 'Select Error Page',
        type: 'dropdown',
        optionsType: 'pageApi',
        options: [],
        value: '',
      },
      ...alertMessagesArgsConfig,
    ],
  },
  {
    name: 'signUpWithOAuth2',
    label: 'Sign Up with OAuth 2',
    args: [userRoleArgsConfig({}), ...redirectUrlArgsConfig, ...alertMessagesArgsConfig],
  },
];
